var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.deleting)?_c('v-progress-circular',{attrs:{"indeterminate":"","size":"20","color":"red"}}):_vm._e(),(!_vm.deleting)?_c('v-icon',{attrs:{"color":"error"},on:{"click":_vm.deleteRule}},[_vm._v("mdi-delete")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }